import type { FC } from 'react'
import type { CardMeta } from './types'
import CardInfoButton from './CardInfoButton'

type KpiCardProps = {
  title: string
  value: string | number
  sub: string
  onClick?: () => void
  meta?: CardMeta
}

const KpiCard: FC<KpiCardProps> = ({ title, value, sub, onClick, meta }) => (
  <div className='flex flex-col flex-1'>
    <div
      className='card h-100 cursor-pointer flex-1'
      style={{ borderRadius: '16px', transition: 'transform .15s' }}
      onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-2px)')}
      onMouseLeave={e => (e.currentTarget.style.transform = '')}
      onClick={onClick}
    >
      <div className='card-body d-flex flex-column'>
        <div className='d-flex align-items-center justify-content-between mb-1'>
          <span className='text-muted text-uppercase' style={{ fontSize: '10px', letterSpacing: '0.5px' }}>{title}</span>
          {meta && (
            <span onClick={e => e.stopPropagation()}>
              <CardInfoButton meta={meta} />
            </span>
          )}
        </div>
        <div className='fw-bold text-dark mb-1' style={{ fontSize: '24px' }}>
          {value}
        </div>
        <div className='text-muted mb-2' style={{ fontSize: '10px' }}>{sub}</div>
        <div className='mt-auto'></div>
        <span className='fw-bold mt-2' style={{ fontSize: '10px', cursor: 'pointer' }} onClick={e => { e.stopPropagation(); onClick?.() }}>
          View details →
        </span>
      </div>
    </div>
  </div>
)

export default KpiCard
